type PersistedState = Record<string, unknown> | null | undefined

const flushPlanningRecordAndLetterSlices = (state: PersistedState): PersistedState => {
  if (!state) {
    return state
  }

  const nextState: Record<string, unknown> = { ...state }

  delete nextState.planningRecord
  delete nextState.planningRecords
  delete nextState.companyPlanningRecord
  delete nextState.companyPlanningRecordLetters

  return nextState
}

const migrations = {
  // migration key needs to match persist config version number
  0: (state: PersistedState): PersistedState => {
    return state
  },
  2: flushPlanningRecordAndLetterSlices,
}

export default migrations
